import React, { useEffect } from 'react';
import { Button, Dialog, Grid, Typography } from '@mui/material';
import { colorPrimary, colorTextBlack } from '../../../config/theme';
import { addNewContent } from '../../../redux/reducers/contentSlice';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { LoadingButton } from '@mui/lab';

const ValidationForNewQuizModal = ({
  open,
  handleClose,
  saveDisabled,
  formik,
  fileType,
  fileDuration,
  file,
  thumbnailFile
}) => {
  const { authData } = useSelector(state => state.auth);
  const { isAddNewContentLoading, isAddNewContentSuccess } = useSelector(
    state => state.content
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (!isAddNewContentLoading && isAddNewContentSuccess) {
      handleClose();
    }
  }, [isAddNewContentSuccess, isAddNewContentLoading]);

  const handleSubmit = () => {
    const addPayload = {
      uploadType: fileType || '',
      title: formik?.contentTitle,
      description: formik?.contentDescription,
      duration: fileDuration,
      sectionId: formik?.section?.id,
      contentType: formik?.contentType?.label,
      contentVisibility: formik?.contentVisibility?.label,
      grade: formik?.grade?.id,
      tagNames: formik?.tags?.map(tag => tag.label),
      status: 'Saved',
      loggedInUserName: authData?.userName
    };

    const formData = new FormData();
    formData.append('file', file);
    formData.append('thumbnail', thumbnailFile);

    formData.append('content', JSON.stringify(addPayload));
    dispatch(addNewContent(formData));
  };
  return (
    <Dialog
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '8px'
        }
      }}
      open={open}
      onClose={() => {
        handleClose();
      }}
    >
      <Grid sx={{ padding: '40px', width: '496px' }}>
        <Typography
          fontSize={'16px'}
          color={colorTextBlack}
          fontWeight={'600'}
          mb={0.5}
        >
          Before proceeding to add the quiz, please confirm whether you would
          like to save the content data.
        </Typography>

        <Grid mt={3} item display={'flex'} justifyContent={'start'} gap={2}>
          <Button
            variant="outlined"
            onClick={() => handleClose()}
            sx={{
              px: 4,
              borderColor: colorPrimary,
              borderRadius: '10px',
              color: 'black',
              borderWidth: '2px',
              height: '42px',
              width: '106px',
              '&:hover': {
                borderColor: colorPrimary,
                backgroundColor: 'transparent',
                borderRadius: '10px',
                borderWidth: '2px'
              }
            }}
          >
            Cancel
          </Button>
          <LoadingButton
            variant="contained"
            disabled={saveDisabled}
            sx={{ mr: 2, px: 4, borderWidth: 2, width: '90px' }}
            onClick={handleSubmit}
            loading={isAddNewContentLoading}
          >
            Save
          </LoadingButton>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default ValidationForNewQuizModal;
